import React from 'react';
import './css/ourteam.css';
import { useLanguage } from '../context/LanguageContext';

const OurTeam = () => {
    const { t } = useLanguage();

    const TeamMems = [
        { 
            id: 1, 
            image: '/team/Eleonora.png', 
            name: 'Eleonora Poddubitskaya'
        },
        { 
            id: 2, 
            image: '/team/CHAYMAE BOURZIK.png', 
            name: 'Chaymae Bourzik'
        },
        { 
            id: 3, 
            image: '/team/ASRAA EISA ELNNAOU.png', 
            name: 'Asraa Eisa Elnnaou'
        },
        { 
            id: 4, 
            image: '/team/Irshad Npk.png', 
            name: 'Irshad Npk'
        }
    ];

    return (
        <section id="team-section" className='our-team'>
            <div className='container'>
                <div className='section-header'>
                    <h1> {t('ourTeam.title')} </h1>
                </div>

                <div className='row'>
                    {TeamMems.map((member, index) => (
                        <div key={member.id} className='col-lg-3 col-md-6 col-12'>
                            <div className='team-mem'>
                                <img 
                                    src={member.image} 
                                    alt={member.name}
                                />
                                <div className='text'>
                                    <h3> {member.name} </h3>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default OurTeam
